import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteCourseMutationVariables = Types.Exact<{
  input: Types.DeleteCourseInput;
}>;


export type DeleteCourseMutation = { __typename?: 'MutationRoot', deleteCourse: { __typename?: 'Course', id: string, name: string } };

export type UpdateCourseMutationVariables = Types.Exact<{
  input: Types.UpdateCourseInput;
}>;


export type UpdateCourseMutation = { __typename?: 'MutationRoot', updateCourse: { __typename?: 'Course', id: string, name: string, isVisibleToAllUserGroups: boolean } };

export type CopyCourseMutationVariables = Types.Exact<{
  input: Types.CopyCourseInput;
}>;


export type CopyCourseMutation = { __typename?: 'MutationRoot', copyCourse: { __typename?: 'Course', id: string, name: string } };


export const DeleteCourseDocument = gql`
    mutation deleteCourse($input: DeleteCourseInput!) {
  deleteCourse(input: $input) {
    id
    name
  }
}
    `;

export function useDeleteCourseMutation() {
  return Urql.useMutation<DeleteCourseMutation, DeleteCourseMutationVariables>(DeleteCourseDocument);
};
export const UpdateCourseDocument = gql`
    mutation updateCourse($input: UpdateCourseInput!) {
  updateCourse(input: $input) {
    id
    name
    isVisibleToAllUserGroups
  }
}
    `;

export function useUpdateCourseMutation() {
  return Urql.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument);
};
export const CopyCourseDocument = gql`
    mutation copyCourse($input: CopyCourseInput!) {
  copyCourse(input: $input) {
    id
    name
  }
}
    `;

export function useCopyCourseMutation() {
  return Urql.useMutation<CopyCourseMutation, CopyCourseMutationVariables>(CopyCourseDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteCourseMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ deleteCourse })
 *   )
 * })
 */
export const mockDeleteCourseMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteCourseMutationVariables>, GraphQLContext<DeleteCourseMutation>, any>) =>
  graphql.mutation<DeleteCourseMutation, DeleteCourseMutationVariables>(
    'deleteCourse',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCourseMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateCourse })
 *   )
 * })
 */
export const mockUpdateCourseMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateCourseMutationVariables>, GraphQLContext<UpdateCourseMutation>, any>) =>
  graphql.mutation<UpdateCourseMutation, UpdateCourseMutationVariables>(
    'updateCourse',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCopyCourseMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ copyCourse })
 *   )
 * })
 */
export const mockCopyCourseMutation = (resolver: ResponseResolver<GraphQLRequest<CopyCourseMutationVariables>, GraphQLContext<CopyCourseMutation>, any>) =>
  graphql.mutation<CopyCourseMutation, CopyCourseMutationVariables>(
    'copyCourse',
    resolver
  )
